<div
  class="header-bar-wrapper"
  [class.has-last-save]="
  globals.isEnableSaveDraftFeature && globals.model.LastSavedTime
"
>
  <div class="ocbc-header-bar">
    <div class="left-content">
      <img class="logo" src="assets/images/ocbc-bank-logo.png" alt="logo" />
      <div class="divider"></div>
      <div class="title">
        {{ title }}
      </div>
    </div>
    <div
      *ngIf="headerBarState === headerBar.ShowSaveButton"
      class="right-content"
    >
      <div class="right-content-row">

          <span
          *ngIf="globals.model.LastLoginTime"
          class="last-login-time desktop"
          >Last login: {{ globals.model.LastLoginTime }}</span
        >
        <!-- <span
          class="save-icon-text save-as-draft"
          (click)="onClickSaveAsDraft()"
        >
          <img src="assets/icons/ic-save@3x.svg" alt="" />
          <span class="d-none d-lg-block">Save as draft</span>
        </span> -->
        <span class="save-icon-text" (click)="onClickSaveAndExit(content)">
          <img src="assets/icons/ic-exit@3x.svg" alt="" />
          <span class="d-none d-lg-block">Save and exit</span>
        </span>
      </div>
      <div class="right-content-row"  *ngIf="globals.isEnableSaveDraftFeature && globals.model.LastSavedTime">
        <span class="last-save-time desktop"
          >Last save was {{ globals.model.LastSavedTime | timeAgo }}</span
        >
      </div>
      <!--    <div>{{ dateString | timeAgo }}</div>-->
    </div>
  </div>
  <div
  *ngIf="
  globals.isEnableSaveDraftFeature &&
  globals.model.LastSavedTime &&
  globals.showLastTimeSavedMobile
"
    class="last-save-time mobile"
  >
    Last save was {{ globals.model.LastSavedTime | timeAgo }}
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <div class="modal-title">
      <span>Exit for now?</span>
    </div>
  </div>
  <div class="modal-body">
    We will save what you have completed so that you can resume with the
    Financial Needs Analysis at a later time.
  </div>
  <div class="modal-footer">
    <app-primary-button [outline]="true" (click)="modal.dismiss()"
      >Cancel</app-primary-button
    >
    <app-primary-button (click)="modal.close()"
      >Save and exit</app-primary-button
    >
  </div>
</ng-template>
